import IndexPage from "."

export default function () {
  return IndexPage
}
